import makeStyles from '@mui/styles/makeStyles';
import { Card, CardContent, CardHeader, Grid, type Theme } from '@mui/material';
import { useCustomersStore } from '@lib/store';
import { CustomersSearchForm, CustomersTable } from './widgets';

const useStyles = makeStyles<Theme>((theme) => ({
  grid: {
    padding: theme.spacing(1),
  },
}));

export const CustomersPage = () => {
  const { loading, data: customers } = useCustomersStore();

  const classes = useStyles();

  return (
    <Grid container alignContent='center'>
      <Grid className={classes.grid} item xs={12} md={3} xl={2}>
        <Card className={classes.card}>
          <CardHeader title='Filter Customers' />
          <CardContent style={{ paddingTop: 0 }}>
            <CustomersSearchForm />
          </CardContent>
        </Card>
      </Grid>
      <Grid className={classes.grid} item xs={12} md={9} xl={10}>
        <Card>
          <CardHeader title='Customers' />
          <CustomersTable loading={loading} data={customers} />
        </Card>
      </Grid>
    </Grid>
  );
};
